<template>
    <div class="grid gap-1 max-w-xl">
        <div class="delete-absolute-btn">
            <DialogUI
                :id="formData.id"
                :name="formData.name"
                :identity="formData.identity"
                @record="record"
            />
        </div>
        <RouterLink
            :to="`/competition/${activityId}/apply`"
            class="flex items-center my-5"
        >
            <span class="material-icons text-xl">reply</span>
            &nbsp;
            <span>回上一層</span>
        </RouterLink>
        <p>{{ id && id !== "create" ? "編輯" : "創建" }}報名</p>
        <v-form
            ref="form"
            lazy-validation
        >
            <table
                class="border-separate"
                style="border-spacing: 20px"
            >
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            報考項目
                        </p>
                    </th>
                    <td>
                        <v-select
                            v-model="formData.competition"
                            :items="competitionList"
                            :rules="emptyRule"
                            :disabled="id !== 'create'"
                            item-text="name"
                            item-value="id"
                            outlined
                        />
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            考場選擇
                        </p>
                    </th>
                    <td>
                        <v-select
                            v-model="formData.place"
                            :items="fieldOptions"
                            :rules="emptyRule"
                            :item-text="(item) => `${item.name}（${item.address}）`"
                            item-value="name"
                            outlined
                        />
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            姓名
                        </p>
                    </th>
                    <td>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    v-model="formData.name"
                                    :rules="emptyRule"
                                    outlined
                                />
                            </v-col>
                            <v-col>
                                <v-radio-group
                                    v-model="formData.gender"
                                    :rules="emptyRule"
                                    row
                                >
                                    <v-radio
                                        label="男"
                                        value="男"
                                    />
                                    <v-radio
                                        label="女"
                                        value="女"
                                    />
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            准考證號碼
                        </p>
                    </th>
                    <td>
                        <v-text-field
                            v-model="formData.admitCardId"
                            disabled
                            outlined
                        />
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            身分證字號
                        </p>
                    </th>
                    <td>
                        <v-text-field
                            v-model="formData.identity"
                            :rules="identity"
                            outlined
                        />
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            出生日期
                        </p>
                    </th>
                    <td>
                        <v-row>
                            <v-col>
                                <v-select
                                    v-model="formData.birthYear"
                                    :items="generateNumberArray(83, getNowChineseYear())"
                                    :rules="emptyRule"
                                    label="年"
                                    outlined
                                />
                            </v-col>
                            <v-col>
                                <v-select
                                    v-model="formData.birthMonth"
                                    :items="generateNumberArray(1, 12)"
                                    :rules="emptyRule"
                                    label="月"
                                    outlined
                                />
                            </v-col>
                            <v-col>
                                <v-select
                                    v-model="formData.birthDay"
                                    :items="generateNumberArray(1, 31)"
                                    :rules="emptyRule"
                                    label="日"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            就讀學校
                        </p>
                    </th>
                    <td>
                        <v-row>
                            <v-col>
                                <v-select
                                    v-model="formData.city"
                                    :items="formOption.city"
                                    :rules="emptyRule"
                                    outlined
                                    label="縣市"
                                />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    v-model="formData.school"
                                    :rules="emptyRule"
                                    label="國小"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            班級
                        </p>
                    </th>
                    <td>
                        <v-row>
                            <v-col>
                                <v-select
                                    v-model="formData.grade"
                                    :items="['一', '二', '三', '四', '五', '六']"
                                    :rules="emptyRule"
                                    label="年"
                                    outlined
                                />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    v-model="formData.class"
                                    :rules="emptyRule"
                                    label="班"
                                    outlined
                                />
                            </v-col>
                        </v-row>
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            家長姓名
                        </p>
                    </th>
                    <td>
                        <v-text-field
                            v-model="formData.parentName"
                            :rules="emptyRule"
                            outlined
                        />
                    </td>
                </tr>
                <tr>
                    <th
                        class="whitespace-nowrap text-left"
                        colspan="2"
                    >
                        通訊地址(寄送准考證、贈品及試後成績單所用)
                    </th>
                </tr>
                <tr>
                    <td>
                        <v-text-field
                            v-model="formData.postalCode"
                            :rules="emptyRule"
                            label="郵遞區號"
                            outlined
                        />
                    </td>
                    <td>
                        <v-text-field
                            v-model="formData.address"
                            :rules="emptyRule"
                            label="地址"
                            outlined
                        />
                    </td>
                </tr>
                <tr v-if="formData.cellphone">
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            手機（個人）
                        </p>
                    </th>
                    <td>
                        <v-text-field
                            v-model="formData.cellphone"
                            :rules="emptyRule"
                            outlined
                        />
                    </td>
                </tr>
                <tr v-if="formData.telephone">
                    <th class="whitespace-nowrap text-left">
                        <p class="mb-7">
                            電話
                        </p>
                    </th>
                    <td>
                        <v-text-field
                            v-model="formData.telephone"
                            :rules="emptyRule"
                            outlined
                        />
                    </td>
                </tr>
                <tr v-if="formData.groupCellphone">
                    <th class="whitespace-nowrap text-left">
                        手機（團體）
                    </th>
                    <td class="text-gray-400">
                        {{ formData.groupCellphone }}
                    </td>
                </tr>
                <tr>
                    <th class="whitespace-nowrap text-left">
                        報名日期
                    </th>
                    <td class="text-gray-400">
                        {{ formData.createTime | formatDate }}
                    </td>
                </tr>
                <tr v-if="!formData.paid">
                    <th class="whitespace-nowrap text-left">
                        繳費序號
                    </th>
                    <td class="text-gray-400">
                        {{ formData.serial }}（未繳費）
                    </td>
                </tr>
                <!-- <tr>
                    <td colspan="2">
                        <v-switch
                            v-model="formData.paid"
                            inset
                            :label="formData.paid ? '已繳費' : '未繳費'"
                            @change="
                                UpdatePayStatus({
                                    id,
                                    status: formData.paid,
                                })
                            "
                        />
                    </td>
                </tr> -->
            </table>
            <v-divider class="mb-5" />
            <table
                class="border-separate"
                style="border-spacing: 20px 0px; width: 100%"
            >
                <tr>
                    <th
                        class="whitespace-nowrap text-left"
                        style="width: 112.453px; vertical-align: baseline"
                    >
                        <p class="mb-7">
                            備註
                        </p>
                    </th>
                    <td>
                        <v-textarea
                            v-model="formData.remark"
                            placeholder="備註內容"
                            outlined
                            no-resize
                            rows="3"
                            class="fixed-textarea"
                        />
                    </td>
                </tr>
            </table>
        </v-form>
        <div class="flex justify-center">
            <!-- <v-btn
                v-if="id && id !== 'create'"
                text
                color="error"
                @click="handleDelete()"
            >
                刪除
            </v-btn> -->
            <v-btn
                text
                @click="$router.push(`/competition/${activityId}/apply`)"
            >
                返回
            </v-btn>
            <v-btn
                color="primary"
                class="ml-2"
                @click="handleSubmit()"
            >
                儲存
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { MessageBox } from 'element-ui';
import _ from 'lodash';
import formOption from '@/assets/form-options.json';
import { generateNumberArray, getNowChineseYear } from '@/utils/methods';
import {
    isNationalIdentificationNumberValid,
    isNewResidentCertificateNumberValid,
} from 'taiwan-id-validator';
import DialogUI from '@/components/DialogUI.vue';
// import DatePicker from '@/components/VDatePicker.vue';

const initData = () => ({
    paid: false,
    activity: '',
    activityDisplay: '',
    competition: '',
    competitionDisplay: '',
    place: '',
    name: '',
    gender: '',
    identity: '',
    birthYear: '',
    birthMonth: '',
    birthDay: '',
    city: '',
    school: '',
    grade: '',
    class: '',
    parentName: '',
    telephone: '',
    cellphone: '',
    postalCode: '',
    address: '',
    remark: '',
    groupCellphone: '',
    groupPassword: '',
    admitCardId: '',
    date: '',
    score: '',
    prize: '',
    rank: '',
    percentileRank: '',
    certification: '',
    certificationItem: '',
    certificationClass: '',
    certificationPrize: '',
    certificationYear: '',
    certificationMonth: '',
    certificationDay: '',
    hash: '',
    serial: '',
    subjects: [],
    createTime: '',
    id: '',
});
export default {
    components: {
        // DatePicker,
        DialogUI,
    },
    props: {
        id: {
            type: String,
            default: () => 'create',
        },
        activityId: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            formOption,
            formData: initData(),
            emptyRule: [(v) => !!v || '此欄位為必填'],
            identity: [
                (v) => isNationalIdentificationNumberValid(v)
                    || isNewResidentCertificateNumberValid(v)
                    || '身份證 格式有誤',
            ],
        };
    },
    computed: {
        ...mapState('mCompetition', ['competitionList']),
        fieldOptions() {
            return this.formData.competition
                ? this.competitionList.find(({ id }) => this.formData.competition === id)?.locations
                : [];
        },
    },
    created() {
        this['mCompetition/List']({
            filter: `activity:${this.activityId}`,
        });
        if (this.id !== 'create') {
            this.Fetch(this.id).then((res) => {
                _.assign(this.formData, res.data);
            });
        }
    },
    methods: {
        ...mapActions('mApply', ['Fetch', 'Create', 'Delete', 'Update', 'UpdatePayStatus']),
        ...mapActions(['mCompetition/List']),
        generateNumberArray,
        getNowChineseYear,
        clearForm() {
            this.formData = initData();
            setTimeout(this.$refs.form.reset, 100);
        },
        handleSubmit() {
            if (this.$refs.form.validate()) {
                if (this.id && this.id !== 'create') {
                    console.log(this.formData);
                    this.Update({ id: this.id, data: this.formData });
                } else {
                    this.Create(this.formData).then((res) => {
                        this.$router.push(`/competition/${this.activityId}/apply/${res.data.id}`);
                    });
                }
            }
        },
        handleDelete() {
            MessageBox.confirm(this.formData.name, {
                type: 'warning',
                title: '確認刪除？',
                confirmButtonText: '刪除',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.Delete(this.id).then(() => this.$router.push(`/competition/${this.activityId}/apply`));
                })
                .catch(() => {});
        },
        record() {
            this.$router.push(`/competition/${this.activityId}/apply`);
        },
    },
};
</script>
<style lang="scss">
.delete-absolute-btn {
    position: absolute;
    top: 50px;
    right: 30px;
    .v-btn {
        padding: 0 20px !important;
    }
}

textarea::placeholder {
    color: rgba(156,163,175) !important;
}
</style>
